module.exports = __webpack_public_path__ + "img/bg-modal.42a5a2ae.png";